export const SEO_PAGES_3 = {
  "youtube-music-promotion": {
    title: "YouTube Music Promotion in India | Millionaire Connector",
    description:
      "YouTube music promotion for artists and labels — audience-targeted campaigns for official music videos, lyrical videos and audio premieres, matched by language and genre. Get a quote on WhatsApp.",
    overline: "YouTube Music Promotion",
    h1: "YouTube Music Promotion That Gets Videos",
    h1Highlight: "Watched",
    intro:
      "YouTube is where music videos live longest. Our YouTube music promotion builds audience-targeted campaigns for official videos, lyrical videos and audio premieres — matched by language, genre and region, and coordinated with your Spotify and Reels pushes.",
    sections: [
      {
        h: "What We Promote On YouTube",
        paras: [
          "YouTube rewards watch time and genuine audience fit. We structure campaigns around the formats that matter for music releases:",
        ],
        list: [
          "Official music videos — release-week audience pushes",
          "Lyrical videos — sustained discovery after release",
          "Audio premieres — coordinated first-day momentum",
          "Shorts — hook-first clips that feed the full video",
        ],
      },
      {
        h: "How YouTube Campaigns Work",
        paras: [
          "You send us the video link, release plan and target audience. We build a campaign around language, genre and region — a Haryanvi video and a Bollywood-style Hindi video need completely different audiences — then launch and share performance updates as the campaign runs.",
          "YouTube promotion works best as part of a coordinated release: Reels create the hook, Spotify captures the streams, and YouTube holds the long-form audience.",
        ],
      },
      {
        h: "Honest Expectations",
        paras: [
          "We do not promise guaranteed views, guaranteed trending positions or guaranteed monetization milestones — no honest agency can. What we structure is audience-targeted delivery with transparent reporting, so your video reaches viewers who actually watch your genre.",
        ],
      },
    ],
    faqs: [
      {
        q: "What is YouTube music promotion?",
        a: "It is the promotion of your music video, lyrical video or audio release to targeted YouTube audiences — matched by language, genre and region — to grow genuine views and channel discovery.",
      },
      {
        q: "Can you guarantee views or YouTube trending?",
        a: "No. Views depend on audience response and YouTube's own systems. We commit to targeted campaign delivery and transparent reporting, not fixed view counts.",
      },
      {
        q: "How do I start a YouTube campaign?",
        a: "Send your video link and release date on WhatsApp with your target audience. We will recommend a campaign structure and quote for your goals.",
      },
    ],
    related: [
      { label: "Spotify Playlist Promotion", to: "/spotify-playlist-promotion" },
      { label: "Instagram Reels Promotion", to: "/instagram-reels-promotion" },
      { label: "Music Promotion", to: "/music-promotion" },
      { label: "Artist Promotion", to: "/artist-promotion" },
    ],
    cta: { title: "Promote Your Music Video", label: "GET CAMPAIGN QUOTE" },
    serviceName: "YouTube Music Promotion",
    serviceDesc:
      "YouTube music promotion for Indian artists and labels: audience-targeted campaigns for music videos, lyrical videos and audio premieres, matched by language and genre.",
  },

  "artist-promotion": {
    title: "Artist Promotion Agency in India | Millionaire Connector",
    description:
      "Full-stack artist promotion in India — Spotify playlist campaigns, Instagram Reels, YouTube promotion and lyrics pages coordinated into one release strategy. 800+ clients served. Quote on WhatsApp.",
    overline: "Artist Promotion",
    h1: "Artist Promotion That Builds",
    h1Highlight: "Real Momentum",
    intro:
      "A great release campaign is not five separate experiments — it is one coordinated push. Our artist promotion combines Spotify playlist promotion, Instagram Reels campaigns, YouTube promotion and lyrics-page networks into a single release strategy built around your music.",
    sections: [
      {
        h: "Full-Stack Promotion For Every Release",
        paras: [
          "Each channel does a different job. Reels make your hook familiar, Spotify playlists convert attention into streams, YouTube holds the long-form audience, and lyrics pages keep the song circulating after release week. We coordinate all of them around one timeline.",
        ],
        list: [
          "Spotify playlist promotion — 1,000+ active playlist network",
          "Instagram Reels campaigns — 250+ creators per major region",
          "YouTube music promotion — audience-targeted video campaigns",
          "Lyrics pages — 100+ Punjabi and 100+ Haryanvi pages",
          "Campaign reporting across every channel",
        ],
      },
      {
        h: "Strategy Built Around Your Stage",
        paras: [
          "A first release needs a different campaign than a tenth. New artists typically start with a focused Spotify slot and a regional Reels push; established artists scale into bulk Reels, high-volume playlist orders and coordinated video campaigns. We recommend structure based on where you are — not the biggest package.",
        ],
      },
      {
        h: "Who We Work With",
        paras: [
          "Independent artists releasing their first track, established artists scaling a hit, labels managing release calendars, and brands building campaigns around music. 800+ clients served, with many returning for repeat campaigns.",
        ],
      },
    ],
    faqs: [
      {
        q: "What does an artist promotion agency do?",
        a: "It plans and executes everything around your release: playlist campaigns, creator-led Reels pushes, YouTube promotion, lyrics pages and reporting — coordinated as one strategy instead of disconnected posts.",
      },
      {
        q: "Do you work with new artists who have no audience yet?",
        a: "Yes. We have run campaigns taking artists from near-zero to tens of thousands of monthly listeners. Start with a focused Spotify slot and a regional Reels push, then scale with each release.",
      },
      {
        q: "How much does artist promotion cost?",
        a: "Spotify slots start at ₹5,000; Reels and YouTube campaigns are quoted by volume and targeting. Combined packages are custom-quoted — message us on WhatsApp with your release and budget.",
      },
    ],
    related: [
      { label: "Song Promotion Services", to: "/song-promotion" },
      { label: "Spotify Playlist Promotion", to: "/spotify-playlist-promotion" },
      { label: "YouTube Music Promotion", to: "/youtube-music-promotion" },
      { label: "Independent Artist Promotion", to: "/independent-artist-promotion" },
    ],
    cta: { title: "Build My Release Campaign", label: "GET CAMPAIGN QUOTE" },
    serviceName: "Artist Promotion",
    serviceDesc:
      "Full-stack artist promotion in India combining Spotify playlist campaigns, Instagram Reels, YouTube promotion and lyrics-page networks into one release strategy.",
  },
};
